import { getTranslate } from 'legacy-src/utilities/i18n'
import React, { useMemo } from 'react'

import { useGetFilterValue } from '@/legacy-src/components/filters/hooks/useGetFilterValue'
import { useSetFilters } from '@/legacy-src/components/filters/hooks/useSetFilters'
import { useDebouncedState } from '@/legacy-src/hooks/useDebouncedState'
import { solveNewValue } from '@/legacy-src/utilities/reduxHelpers'

import DaysCheckBox from './DaysCheckbox'
import TimesCheckbox from './TimesCheckbox'

const TimeDaysAndTimes: React.FC = () => {
  const { t } = getTranslate()
  const setFilters = useSetFilters()

  const initialTimes = useGetFilterValue('times')
  const filterDaysValue = useGetFilterValue('days')
  const initialDays = useMemo(() => filterDaysValue.map((item) => parseInt(item, 10)), [filterDaysValue])

  const { value: times, onChange: onTimesChange } = useDebouncedState({
    value: initialTimes,
    wait: 1000,
    callback: (newValue) => {
      setFilters([
        { slug: 'times', value: newValue },
        { slug: 'availability', value: [] },
      ])
    },
  })

  const { value: days, onChange: onDaysChange } = useDebouncedState({
    value: initialDays,
    wait: 1000,
    callback: (newValue) => {
      setFilters([
        { slug: 'days', value: newValue.map((item) => item.toString()) },
        { slug: 'availability', value: [] },
      ])
    },
  })

  const handleTimesOnChange = (newValue: string) => {
    onTimesChange(solveNewValue(times, newValue))
  }

  const handleDaysOnChange = (newValue: number) => {
    onDaysChange(solveNewValue(days, newValue))
  }

  return (
    <div className="mt-2 text-base">
      <div className="mb-3 font-bold">{t('components.filter.days.title')}</div>
      <div className="grid grid-cols-2 gap-5">
        <DaysCheckBox days={days} selectDay={handleDaysOnChange} />
      </div>
      <div className="mb-3 mt-6 font-bold">{t('components.filter.times.title')}</div>
      <div className="grid grid-cols-2 gap-5">
        <TimesCheckbox times={times} selectTime={handleTimesOnChange} />
      </div>
    </div>
  )
}

export default TimeDaysAndTimes
